module.exports = __webpack_public_path__ + "static/media/users.82b01860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/users.svg
// module id = 6540
// module chunks = 0